var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tableCon"},[(_vm.resTable.length > 0)?_c('lk-table',{attrs:{"columns":_vm.columns,"data":_vm.resTable}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }